// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectPortfolioStatisticsMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_PORTFOLIO_STATISTICS)

    this.DataArray = [];   // массив DirectPortfolioStatistic 
}

export let DirectPortfolioStatistic = function ()
{
    this.Date = null;                //приходит в FIELD_DATE[12] - Значение “день”,
    this.Percent = null;             //приходит в FIELD_PERCENT[729] - Значение “процентов”,
    this.AbsoluteAmount = null;      //приходит в FIELD_AMOUNT[7] - Значение “абсолютное”,
    this.IsBest = null;              //приходит в FIELD_TYPE[53] - байтовое поле, в рамках тек.задачи, будет использоваться для передачи признака “best” = 1 или “worst” = 0,
    this.TradableInstrumentId = null;//приходит в FIELD_TRADABLE_INSTRUMENT_ID[655] - Идентификатор инструмента,
    this.RouteId = null;             //приходит в FIELD_ROUTE_ID[85] - Идентификатор котировочного роута
}

DirectPortfolioStatisticsMessage.prototype = Object.create(DirectMessageBase.prototype)